export default __webpack_public_path__ + "static/main-wraper-bg-mob-080ea8c06069b8477c55f9464dfdd692.png";